<template>
    <button @click="handleClick" :class="classObject" :disabled="isDisabled" >
        <slot></slot>
    </button>
</template>
<script>
export default {
    props:{
        classObject:{
            type:Object,
            default:null
        },
        isDisabled:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        handleClick(){
            this.$emit('on-click');
        }
    }
}
</script>
<style scoped>
button{
    border: 0;
    width: 60px;
    height: 30px;
    margin-left: 10px;
    cursor: pointer;
    font-size: 14px;
}

</style>